import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    wrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '30px',
    }),

    inputGroupWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',
        marginTop: '30px',
        textTransform: 'uppercase',
    }),

    userMessage: css({
        marginTop: '-20px',
    }),
};
